import { ModelScene, useEntity } from 'components';
import type { Outlet } from 'modules/supplier/outletOrServiceCategory/types';
import type { OutletOrServiceCategoryProduct } from 'modules/supplier/products';
import permissions from 'modules/supplier/vendor/permissions';

import { useProductRoutes } from 'modules/supplier/products/useProductRoutes';
import { getProductTypeModule } from 'productTypes';

export function VendorOutletProducts() {
  const { endpoint, item } = useEntity<Outlet>();
  const url = `${endpoint}products/`;

  const routes = useProductRoutes(item, getProductTypeModule);
  return (
    <ModelScene
      endpoint={url}
      title="Product"
      pluralTitle="Products"
      entityTitle={({ name }: OutletOrServiceCategoryProduct) => name || <em>Unspecified product</em>}
      permissions={permissions}
    >
      {routes}
    </ModelScene>
  );
}
